import React from "react";
import MissionVision from "../components/About/MissionVision";
import FullScreenImage from "../components/Home/ShowcaseSection";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";

const Mission = () => {
  return (
    <div>
      <Navbar />
      <MissionVision />
      <FullScreenImage />
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default Mission;
